module.exports = __webpack_public_path__ + "img/android-only.8945c3cd.svg";